














































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';
import ColorComponent from '@/components/Controls/ColorComponent.vue'

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      name: { required },
    }

    return {
      form: rules
    }
  },
  components: {
    ColorComponent
  }
})
export default class VocabularyManagerForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: String }) table!: string;
  @Prop({ type: Array }) ignore_fields!: any[];
  @Prop({ type: Object }) initParams!: any;

  document!: any
  form!: any

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
      this.$store.dispatch(`${STORE_KEY}/setParams`, {table: this.table});
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

